import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import Image from '../Image';
import useResponsive from '../../hooks/useResponsive';

export default function MyDialog({ open, close, maxSize, children, hasDialogContent = true, ...props }) {
  const isDesktop = useResponsive('up', 'lg');

  const theme = useTheme();

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={maxSize}
        open={open}
        onClose={close}
        scroll="body"
        PaperProps={{
          sx: {
            opacity: '0.90',
            color: '#FFFFFF',
            borderRadius: '16px',
            position: 'relative',
            overflow: 'visible',
            border: '2px solid transparent',
            backgroundImage: `
        linear-gradient(${theme.palette.goldcity.background.main}, ${theme.palette.goldcity.background.main}), 
        linear-gradient(180deg, #FDD146 0%, #F09F0E 100%)
      `,
            backgroundOrigin: 'border-box',
            backgroundClip: 'padding-box, border-box',
            ...props,
          },
        }}
      >
        <IconButton
          onClick={close}
          sx={{
            width: '32px',
            height: '32px',
            position: 'absolute',
            top: isDesktop ? -30 : -12,
            right: isDesktop ? -30 : -12,
            backgroundColor: '#FF9D00',
            boxShadow: 2,
            '&:hover': { backgroundColor: '#656565ff' },
          }}
        >
          <Image src={require('../../assets/home/close.png')} alt="CLOSE" aria-hidden="true" />
        </IconButton>

        {hasDialogContent ? (
          <DialogContent>
            <Box sx={{ px: { xs: 0, md: 3 } }}>{children}</Box>
          </DialogContent>
        ) : (
          <Box>{children}</Box>
        )}
      </Dialog>
    </>
  );
}
